export default function getTicketTemplate() {
  return `
<!DOCTYPE html>
<html>
<head>
    <title>Ticket</title>
    <meta charset='utf-8'>
    <meta http-equiv='X-UA-Compatible' content='IE=edge'>
    <meta content='width=device-width, initial-scale=1' name='viewport'>
    <style>
        *, *:before, *:after {
            box-sizing: border-box;
        }
        body {
            width: 100%;
            margin: 0;
            padding: 0;
            font-size: 12px;
            line-height: 1.5;
            font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
            color: rgb(33,33,33);
        }
        .ticket {
            padding: 20px 30px;
        }
        .logo {
            max-width: 100%;
            max-height: 40px;
        }
        h2 {
            font-size: 14px;
        }
        .text-right {
            text-align: right;
        }
        .text-left {
            text-align: left;
        }
        .row {
            display: block;
            clear: both;
        }
        .row:before, .row:after {
            content: " ";
            display: table;
        }
        .col-sm-3, .col-sm-4, .col-sm-6 {
            float: left;
            position: relative;
            min-height: 1px;
        }
        .col-sm-3 {
            width: 25%;
        }
        .col-sm-4 {
            width: 33.33333%;
        }
        .col-sm-6 {
            width: 50%;
        }
        .ticket-field {
            display: inline-block;
            padding: 5px 0 5px 10px;
        }
        .ticket-field:first-child {
            padding-left: 0;
        }
        .table {
            width: 100%;
            max-width: 100%;
            margin: 20px 0;
            border-collapse: collapse;
            border-spacing: 0;
            background-color: transparent;
        }
        .table > tbody > tr > td, .table > tfoot > tr > th, .table > tfoot > tr > td {
            font-size: 12px;
            padding: 3px 5px;
            line-height: 1.5;
            vertical-align: top;
            border-top: 1px solid rgb(231, 236, 241);
        }
        .table tr th {
            font-size: 12px;
            font-weight: 600;
            padding: 5px;
            vertical-align: bottom;
            border-bottom: 2px solid rgb(231, 236, 241);
        }
        .table > thead:first-child > tr:first-child > th, .table > thead:first-child > tr:first-child > td {
            border-top: 0;
        }
        @page {
            size: A4;
            margin: 0;
        }
        @media print {
            html, .ticket { page-break-after: always; }
        }
    </style>
</head>
<body>
    <div class="ticket">
    {{#if logo}}<img class="logo" src="{{logo}}" />{{/if}}
    <h2>Ticket {{id}}</h2>
    <div class="tickets-item">
        {{#compare onlyWeights '===' 'true'}}
            <div class="row">
                <div class="col-sm-4">
                    <span class="ticket-field"><strong class="ticket-field-label">Date: </strong>
                      <span>{{formatTimeTZ loadStartTime 'LL' timezone}}</span>
                    </span>
                </div>
            </div>
        {{else}}
            <div class="row">
                <div class="col-sm-3">
                    <span class="ticket-field"><strong class="ticket-field-label">Date: </strong>
                      <span>{{formatTimeTZ loadStartTime 'LL' timezone}}</span>
                    </span>
                </div>
                <div class="col-sm-3">
                    <span class="ticket-field"><strong class="ticket-field-label">Plant: </strong>
                      <span>{{escape plantName}}</span>
                    </span>
                </div>
                <div class="col-sm-3">
                    <span class="ticket-field"><strong class="ticket-field-label">Truck: </strong>
                      <span>{{escape truckCode}}</span>
                    </span>
                </div>
                <div class="col-sm-3">
                    <span class="ticket-field"><strong class="ticket-field-label">Driver: </strong>
                      <span>{{escape driverName}}</span>
                    </span>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-3">
                    <span class="ticket-field"><strong class="ticket-field-label">Code: </strong>
                      <span>{{code}}</span>
                    </span>
                </div>
                <div class="col-sm-3">
                    <span class="ticket-field"><strong class="ticket-field-label">Order Code: </strong>
                      <span>{{dispatchOrderCode}} {{batchOrderCode}}</span>
                    </span>
                </div>
                <div class="col-sm-3">
                    <span class="ticket-field"><strong class="ticket-field-label">Ticket Code: </strong>
                      <span>{{dispatchTicketCode}}</span>
                    </span>
                </div>
                <div class="col-sm-3">
                    <span class="ticket-field"><strong class="ticket-field-label">Job: </strong>
                      <span>{{dispatchOrderJobNumber}}</span>
                    </span>
                </div>
                <div class="col-sm-3">
                    <span class="ticket-field"><strong class="ticket-field-label">PO: </strong>
                      <span>{{purchaseOrderNumber}}</span>
                    </span>
                </div>
                <div class="col-sm-6">
                    <span class="ticket-field"><strong class="ticket-field-label">Payment Form: </strong>
                      <span>{{paymentForm}}</span>
                    </span>
                </div>
                <div class="col-sm-6">
                    <span class="ticket-field"><strong class="ticket-field-label">Zone Code: </strong>
                      <span>{{zoneCode}}</span>
                    </span>
                </div>
                <div class="col-sm-3">
                    <span class="ticket-field"><strong class="ticket-field-label">Customer: </strong>
                      <span>{{escape customerCode}}</span>
                    </span>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-3">
                    <span class="ticket-field"><strong class="ticket-field-label">Project: </strong>
                      <span>{{escape projectCode}}</span>
                    </span>
                </div>
                <div class="col-sm-3">
                    <span class="ticket-field"><strong class="ticket-field-label">Project Name: </strong>
                      <span>{{escape projectName}}</span>
                    </span>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <span class="ticket-field"><strong class="ticket-field-label">Sold to: </strong>
                      <span>{{escape customerAddress}}</span>
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <span class="ticket-field"><strong class="ticket-field-label">Delivered to: </strong>
                      <span>{{escape shipToAddress}}</span>
                    </span>
                </div>
            </div>

            <table class="table table-striped table-ticket-products">
            <thead>
            <tr>
                <th class="text-left">Code</th>
                <th class="text-left">Description</th>
                <th class="text-left">Qty</th>
                <th class="text-left">Unit</th>
                <th class="text-right">Unit price</th>
                <th class="text-right">Amount</th>
            </tr>
            </thead>

            <tbody>

            {{#each products}}
                <tr>
                    <td>{{escape itemCode}}</td>
                    <td>{{escape itemDescription}}</td>
                    <td>{{toFixed quantity 2}}</td>
                    <td>{{unitSymbol}}</td>
                    <td class="text-right">$ {{toFixed unitPrice 2}}</td>
                    <td class="text-right">$ {{toFixed (multiply quantity unitPrice) 2}}</td>
                </tr>
            {{/each}}

            <tr class="row-ticket-products-total">
                <td colSpan="4" rowSpan="3"></td>
                <td class="text-right"><strong>Sub Total: </strong></td>
                <td class="text-right">{{#if ticketSubTotal}} $ {{toFixed ticketSubTotal 2}}{{/if}}</td>
            </tr>
            <tr class="row-ticket-products-total">
                <td class="text-right"><strong>TAX: </strong></td>
                <td class="text-right">{{#if ticketTaxTotal}} $ {{toFixed ticketTaxTotal 2}}{{/if}}</td>
            </tr>
            <tr class="row-ticket-products-total">
                <td class="text-right"><strong>Total:</strong></td>
                <td class="text-right">{{#if ticketTotal}} $ {{toFixed ticketTotal 2}}{{/if}}</td>
            </tr>
            </tbody>

            <tfoot>
            <tr>
                <td colSpan="6">
                  <span class="ticket-field"><strong class="ticket-field-label">Ordered: </strong> <span
                  >{{orderMixQuantity}}</span></span>
                    <span class="ticket-field"><strong class="ticket-field-label">Delivered: </strong> <span
                    >{{orderDeliveredToDateMixQuantity}}</span></span>
                    <span class="ticket-field"><strong class="ticket-field-label">Slump: </strong> <span
                    >{{mixSlump}}</span></span>
                </td>
            </tr>
            </tfoot>

        </table>

        {{/compare}}

        {{#if loadEndTime}}
            <div class="row">
            <div class="col-sm-4">
                <span class="ticket-field">
                  <strong class="ticket-field-label">Batch start: </strong>
                  <span>{{formatTimeTZ loadStartTime 'h:mm:ss A' timezone}}</span>
                </span>
            </div>

            <div class="col-sm-4">
                <span class="ticket-field">
                  <strong class="ticket-field-label">Batch end: </strong>
                  <span>{{formatTimeTZ loadEndTime 'h:mm:ss A' timezone}}</span>
                </span>
            </div>
            <div class="col-sm-4">
                <span class="ticket-field">
                  <strong class="ticket-field-label">Batch time:</strong>
                  <span>{{batchTime}}</span>
                </span>
            </div>
            {{#compare showManualLoad '===' 'true'}}
            <div class="col-sm-4">
                <span class="ticket-field">
                    <strong class="ticket-field-label">
                    {{#compare manualLoad '===' 'true'}} Manual Batch {{else}} Automatic Batch {{/compare}}
                    </strong>
                </span>
            </div>
            {{/compare}}
            {{#compare isAborted '===' 'true'}}
            <div class="col-sm-4">
                <span class="ticket-field">
                    <strong class="ticket-field-label">
                    Load Aborted
                    </strong>
                </span>
            </div>
            {{/compare}}
        </div>
        {{/if}}

        {{#if results}}
            <table class="table table-striped table-ticket-products">
                <thead>
                <tr>
                    <th></th>
                    <th class="text-right">Design</th>
                    <th class="text-right">Target</th>
                    <th class="text-right">Actual</th>
                    <th class="text-right">VAR</th>
                    <th class="text-right">% VAR</th>
                    <th class="text-right">% Moisture</th>
                </tr>
                </thead>

                <tbody>
                {{#each results}}
                    <tr>
                        <td><strong>{{{displayName}}} {{#compare manuallyTerminated '===' 'true'}} * {{/compare}}</strong></td>
                        <td class="text-right">{{escape mix}} {{unitSymbol}}</td>
                        <td class="text-right">{{target}} {{unitSymbol}}</td>
                        <td class="text-right">{{actual}} {{unitSymbol}}</td>
                        <td class="text-right">{{toFixed (subtract actual target) 2}}</td>
                        <td class="text-right">{{#if target}}{{toFixed (divide (multiply 100 (subtract actual target)) target) 2}}{{else}}0{{/if}} %</td>
                        <td class="text-right">
                            {{#compare moisture '>' 0}}
                                {{moisture}}%
                                {{toFixed actualWater 2}} {{../waterUnit}}
                            {{/compare}}
                        </td>
                    </tr>
                {{/each}}

                </tbody>

            </table>

            <div class="row">
            <div class="col-sm-4">
                <span class="ticket-field">
                  <strong class="ticket-field-label">Total Load: </strong>
                  <span>{{toFixed totalLoad 2}} {{unit}}</span>
                </span>
            </div>
            <div class="col-sm-4">
                <span class="ticket-field">
                  <strong class="ticket-field-label">Design W/C Ratio: </strong>
                  <span>{{toFixed designWaterCementRatio 3}}</span>
                </span>
            </div>
            <div class="col-sm-4">
                <span class="ticket-field">
                  <strong class="ticket-field-label">W/C Ratio: </strong>
                  <span>{{toFixed waterCementRatio 3}}</span>
                </span>
            </div>
            <div class="col-sm-4">
                <span class="ticket-field">
                  <strong class="ticket-field-label">Water in Truck:</strong>
                  <span>{{toFixed waterInTruck 2}} {{waterUnit}}</span>
                </span>
            </div>
            <div class="col-sm-4">
                <span class="ticket-field">
                  <strong class="ticket-field-label">Ice:</strong>
                  <span>{{toFixed ice 2}} {{iceUnit}}</span>
                </span>
            </div>
            <div class="col-sm-4">
                <span class="ticket-field">
                  <strong class="ticket-field-label">Total Water:</strong>
                  <span>{{toFixed totalWater 2}} {{waterUnit}}</span>
                </span>
            </div>
            <div class="col-sm-4">
                <span class="ticket-field">
                  <strong class="ticket-field-label">Temper Water:</strong>
                  <span>{{toFixed temperWater 2}} {{temperWaterUnit}}</span>
                </span>
            </div>
        </div>
        {{/if}}

    </div>
    </div>
</body>
</html>`;
}
